// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Phone Number`
};

const de_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonnummer`
};

const es_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Número de Teléfono`
};

const fr_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Numéro de Téléphone`
};

const fi_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Puhelinnumero`
};

const hi_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `फोन नंबर`
};

const ja_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `電話番号`
};

const nl_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefoonnummer`
};

const pt_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Número de Telefone`
};

const ro_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Număr de Telefon`
};

const th_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `หมายเลขโทรศัพท์`
};

const ur_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `فون نمبر`
};

const zh_hant1_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `電話號碼`
};

const da_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonnummer`
};

const it_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Numero di Telefono`
};

const vn_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Số Điện Thoại`
};

const ko_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `전화번호`
};

const tr_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefon Numarası`
};

const lv_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Tālruņa numurs`
};

const ar_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `رقم الهاتف`
};

const bs_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Broj telefona`
};

const sl_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonska številka`
};

const id_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Nomor Telepon`
};

const sv_widget_login_phone_number = /** @type {(inputs: {}) => string} */ () => {
	return `Telefonnummer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_phone_number = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_phone_number(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_phone_number", locale)
	if (locale === "en") return en_widget_login_phone_number(inputs)
	if (locale === "de") return de_widget_login_phone_number(inputs)
	if (locale === "es") return es_widget_login_phone_number(inputs)
	if (locale === "fr") return fr_widget_login_phone_number(inputs)
	if (locale === "fi") return fi_widget_login_phone_number(inputs)
	if (locale === "hi") return hi_widget_login_phone_number(inputs)
	if (locale === "ja") return ja_widget_login_phone_number(inputs)
	if (locale === "nl") return nl_widget_login_phone_number(inputs)
	if (locale === "pt") return pt_widget_login_phone_number(inputs)
	if (locale === "ro") return ro_widget_login_phone_number(inputs)
	if (locale === "th") return th_widget_login_phone_number(inputs)
	if (locale === "ur") return ur_widget_login_phone_number(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_phone_number(inputs)
	if (locale === "da") return da_widget_login_phone_number(inputs)
	if (locale === "it") return it_widget_login_phone_number(inputs)
	if (locale === "vn") return vn_widget_login_phone_number(inputs)
	if (locale === "ko") return ko_widget_login_phone_number(inputs)
	if (locale === "tr") return tr_widget_login_phone_number(inputs)
	if (locale === "lv") return lv_widget_login_phone_number(inputs)
	if (locale === "ar") return ar_widget_login_phone_number(inputs)
	if (locale === "bs") return bs_widget_login_phone_number(inputs)
	if (locale === "sl") return sl_widget_login_phone_number(inputs)
	if (locale === "id") return id_widget_login_phone_number(inputs)
	if (locale === "sv") return sv_widget_login_phone_number(inputs)
	return "widget_login_phone_number"
};